export const isStringBase64 = str => str?.includes('base64')
export const isUrl = str => typeof str === 'string' && str?.startsWith('http')
